import React from 'react';
import * as C from "../componentsM/index"

const ExtraCircullarProgram = () => {
    return (
        <>

            <C.Hero title={"EXTRA CURRICULAR PROGRAMMES"}
                image={"/hero/10.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <div className='flex flex-wrap items-center gap-6'>

                        {
                            ["/program/1.jpg","/program/2.jpg","/program/3.jpg"].map((v, index) => <figure className='md:w-60 md:h-44' key={v}>

                                <img src={v} alt={`Extra curricular programme ${index + 1}`} className='w-full h-full object-cover' />
                            </figure>)
                        }

                    </div>

                    <p>The International School provides a range of extra-curricular programmes. In the PYP, we introduce Taekwondo, Arts Club, Language Arts Club, Science Club, Public Speaking Club, Health & Fitness Club and Performing Arts Club. In addition to all that we have the annual extra-curricular activities like the Swimming Gala, Sports Day and the Drama Festival.</p>


                    <p>The students also go on organised field trips related to the transdisciplinary themes. Students have been to places like the Post Office, the Fire Station, Banks, Maritime Museum, the National Museum and the Zoo, supporting their respective themes.</p>

                    <p>Guest speakers are also called in during the ongoing units to support the unit of inquiry and as a source of information.</p>

                </div>
            </section>

        </>

    )
}

export default ExtraCircullarProgram